<template>
    <div class="form-datos-personales">
        <div>
            <div class="fila-inputs">
                <InputField 
                    inputType = "text" 
                    placeholder = "Nombre"
                    label = "Nombre"
                    :isRequired = "true"
                    :currentValue = "$store.state.prescoringData.nombre"
                    @valueChanged = "(value) => handleValueChanged('nombre',value)" />
                <InputField 
                    inputType = "text" 
                    placeholder = "Apellidos"
                    label = "Apellidos"
                    :isRequired = "true"
                    :currentValue = "$store.state.prescoringData.apellidos"
                    @valueChanged = "(value) => handleValueChanged('apellidos',value)" />
            </div>
            <div class="fila-inputs">
                <PhoneInputField                  
                    :isRequired = "true"
                    :currentValue = "$store.state.prescoringData.telefono"
                    @valueChanged = "(value) => handleValueChanged('telefono',value)" />
            </div>
            <div class="fila-inputs">
                <InputField 
                    inputType = "email" 
                    placeholder = "Email"
                    label = "Email"
                    :isRequired = "true"
                    :currentValue = "$store.state.prescoringData.email"
                    @valueChanged = "(value) => handleValueChanged('email',value)" />
            </div>
        </div>
        <div class="checkBox-container">
        <InputCheckBox 
            id = "my_hello"
            @valueChanged = "(value) => handleValueChanged('my_hello_check',value)"
            :label = "$store.state.newTexts.step_datos_personales[1].label" />
        <InputCheckBox
            id = "my_andbank"
            @valueChanged = "(value) => handleValueChanged('my_andbank_check',value)"
            :label = "$store.state.newTexts.step_datos_personales[2].label" />
        <p v-html= "$store.state.newTexts.step_datos_personales[3].text " style="font-size: 12px; margin: 0"></p>
    </div>
    </div>
</template>

<script>
import InputField from './InputField.vue';
import InputCheckBox from './InputCheckBox.vue';
import PhoneInputField from './PhoneInputField.vue';

export default {
    name: 'DatosPersonalesComponent',
    components: {
        InputField,
        InputCheckBox,
        PhoneInputField
    },
    methods: {
        handleValueChanged(field, value) {
            if(field === 'telefono'){
                this.$store.commit('updatePrescoringData', { field: 'telefono', value: value.numero });
                this.$store.commit('updatePrescoringData', { field: 'prefijo', value: value.prefijo });
            } else {
                this.$store.commit('updatePrescoringData', { field, value });
            }
        }
    }
}
</script>

<style scoped>
    .fila-inputs{
        display: flex;
        gap: 16px; 
    }
    .checkBox-container{
        margin: 24px 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap:24px;
    }
    /* MOVIL */
    @media (max-width: 768px) {
        .fila-inputs{
            flex-direction: column;
            width: 100%;  
            gap: 0;   
        }
        .fila-inputs > *:nth-child(1),
        .fila-inputs > *:nth-child(2) {
            margin-bottom: 16px;
        }
    }
    /* TABLET */
    @media (min-width: 769px) and (max-width: 992px) {
        .fila-inputs{
            display: flex;
            gap: 16px; 
        }
        .fila-inputs > *:nth-child(1),
        .fila-inputs > *:nth-child(2) {
            flex: 1; /* Repartir el espacio equitativamente */
            margin-bottom: 16px;
        }
    }
    /* ESCRITORIO*/
    @media (min-width: 993px) {
        .fila-inputs{
            display: flex;
            gap: 16px; 
        }
        .fila-inputs > *:nth-child(1),
        .fila-inputs > *:nth-child(2) {
            flex: 1; 
            margin-bottom: 16px;
        }
    }

</style>